import { GlCollapse, GlBadge, GlButton, GlIcon, GlSkeletonLoader, GlLoadingIcon } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { projectCommitsPath } from '~/lib/utils/path_helpers/repository';
import { encodeUrlHash } from '~/lib/utils/url_utility';
import { CONTAINING_COMMIT, FETCH_CONTAINING_REFS_EVENT, BRANCHES_REF_TYPE, EMPTY_BRANCHES_MESSAGE, EMPTY_TAGS_MESSAGE } from '../constants';
export default {
    name: 'RefsList',
    components: {
        GlCollapse,
        GlSkeletonLoader,
        GlBadge,
        GlButton,
        GlIcon,
        GlLoadingIcon
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        refType: {
            type: String,
            required: true
        },
        containingRefs: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        tippingRefs: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        namespace: {
            type: String,
            required: true
        },
        hasContainingRefs: {
            type: Boolean,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        FETCH_CONTAINING_REFS_EVENT
    ],
    data () {
        return {
            isContainingRefsVisible: false
        };
    },
    computed: {
        collapseIcon () {
            return this.isContainingRefsVisible ? 'chevron-down' : 'chevron-right';
        },
        isLoadingRefs () {
            return this.isLoading && !this.containingRefs.length;
        },
        refIcon () {
            return this.refType === BRANCHES_REF_TYPE ? 'branch' : 'tag';
        },
        showEmptyMessage () {
            return this.tippingRefs.length === 0 && !this.hasContainingRefs && !this.isLoading;
        },
        showNameSpace () {
            return (this.tippingRefs.length !== 0 || this.hasContainingRefs) && !this.isLoading;
        },
        emptyMessage () {
            return this.refType === BRANCHES_REF_TYPE ? EMPTY_BRANCHES_MESSAGE : EMPTY_TAGS_MESSAGE;
        }
    },
    methods: {
        toggleCollapse () {
            this.isContainingRefsVisible = !this.isContainingRefsVisible;
        },
        showRefs () {
            this.toggleCollapse();
            this.$emit(FETCH_CONTAINING_REFS_EVENT);
        },
        getRefUrl (ref) {
            // projectCommitsPath encodes the ref as a glob param via encodeURI, which
            // preserves `/` (for hierarchical refs) but leaves `#` untouched, so refs
            // like `C#tag` must have it encoded to avoid being read as a URL fragment.
            return encodeUrlHash(projectCommitsPath(this.fullPath, ref, {
                ref_type: this.refType
            }));
        }
    },
    i18n: {
        containingCommit: CONTAINING_COMMIT
    }
};
